import { Component, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ImageCropChangedEvent } from '../image-cropper/image-cropper.component';

export type ImageCropperDialogData = {
  /** The image to crop as a Data URL. */
  sourceImage: string;
};

/** The image cropper will return a cropped PNG image as a Data URI if the user confirmed, or undefined otherwise. */
export type ImageCropperDialogResult = string | undefined;

@Component({
  selector: 'app-image-cropper-dialog',
  templateUrl: './image-cropper-dialog.component.html',
  styleUrl: './image-cropper-dialog.component.scss',
  standalone: false,
})
export class ImageCropperDialogComponent {
  private dialogRef = inject<MatDialogRef<ImageCropperDialogComponent, ImageCropperDialogResult>>(MatDialogRef);

  public sourceImage: string;
  public croppedImage: string;

  constructor() {
    const data = inject<ImageCropperDialogData>(MAT_DIALOG_DATA);

    this.sourceImage = data.sourceImage;
  }

  handleCropChanged(event: ImageCropChangedEvent) {
    this.croppedImage = event.dataUri;
  }

  cancel() {
    this.dialogRef.close();
  }

  submit() {
    this.dialogRef.close(this.croppedImage);
  }
}
